import HtmlParser from "react-html-parser";
import Image from "../../Image";
import { trackTransferToShop } from "../../../utils/analytics";
import { getOutboundLinkRel, isHiddenFromSite } from "../../../utils";
import "./index.css";
const isBrowser = typeof window !== "undefined";
const TopPickCard = ({ product, productDescription = "" }) => {
  return (
    <div className="topPickCard">
      <div className="tpcLeft">
        <Image
          className="lazyload tpcImage"
          src={product?.images ? product?.images[0] : ""}
          alt="product image"
        />
      </div>
      <div className="tpcContent">
        <h2 className="tpcTitle">{product?.title}</h2>
        {isHiddenFromSite(product?.contentProducts?.brand) ? (
          <span className="tpcBrand">{product?.brand_name}</span>
        ) : (
          <a
            className="tpcBrand"
            href={"/brands/" + product?.contentProducts?.brand?.slug}
            target="_blank"
            rel="noopener noreferrer"
          >
            {product?.brand_name}
          </a>
        )}
        <div className="tpcdescription">
          {productDescription
            ? HtmlParser(productDescription)
            : HtmlParser(product?.contentProducts?.productDescription)}
        </div>
        <a
          className="tpcShopNow"
          href={product?.contentProducts?.affiliateUrl}
          target="_blank"
          rel={getOutboundLinkRel({ brand: product?.brand_name })}
          onClick={() => {
            trackTransferToShop({
              affiliateUrl: product?.contentProducts?.affiliateUrl,
              contentType: 'article', // Update based on page context
              surfaceType: 'top_picks_module',
              productTitle: product?.title,
              category: product?.contentProducts?.productCategory?.name || '',
              brand: product?.brand_name || ''
            });
          }}
        >
          Shop Now
        </a>
      </div>
      <div className="tpcBadge1">Top Pick</div>
      <div className="tpcBadge2">
        <div className="mobile-only">
          <svg
            width="9"
            height="11"
            viewBox="0 0 9 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.52538 1.04321H1.91484C1.60914 1.04321 1.31597 1.15319 1.09981 1.34895C0.883645 1.5447 0.762207 1.81021 0.762207 2.08705V10.0898L4.22011 7.30624L7.67801 10.0898V2.08705C7.67801 1.81021 7.55657 1.5447 7.34041 1.34895C7.12425 1.15319 6.83107 1.04321 6.52538 1.04321Z"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div className="desktop-only">
          <svg
            width="20"
            height="26"
            viewBox="0 0 20 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7817 1.9353H4.4083C3.65419 1.9353 2.93097 2.20659 2.39774 2.6895C1.86451 3.1724 1.56494 3.82735 1.56494 4.51028V24.2517L10.095 17.3851L18.6251 24.2517V4.51028C18.6251 3.82735 18.3255 3.1724 17.7923 2.6895C17.259 2.20659 16.5358 1.9353 15.7817 1.9353Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div className="cardDownArrow"></div>
    </div>
  );
};

export default TopPickCard;
